var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixMistakes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.652 3.555A8 8 0 108 16a1 1 0 100-2 6 6 0 116-6 1 1 0 102 0 8 8 0 00-1.348-4.445z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.586l-1.293-1.293a1 1 0 10-1.414 1.414L11.586 13l-1.293 1.293a1 1 0 101.414 1.414L13 14.414l1.293 1.293a1 1 0 001.414-1.414L14.414 13l1.293-1.293a1 1 0 00-1.414-1.414L13 11.586zm-2.707-6.293L7 8.586 5.707 7.293l-.094-.083a1 1 0 00-1.32 1.497l2 2 .094.083a1 1 0 001.32-.083l4-4 .083-.094a1 1 0 00-1.497-1.32z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixMistakes);
export default __webpack_public_path__ + "static/media/fix-mistakes.bfdc3e648fd5ff686360d7d85d8c6386.svg";
export { ForwardRef as ReactComponent };